import { createPortal } from "react-dom";

/**
 * Capa de modal genérica: usar SIEMPRE esto en lugar de un `<div className="fixed inset-0 ...">`.
 *
 * - Se renderiza en `document.body`. `<main>` crea su propio contexto de apilamiento (z-10) y un
 *   overlay renderizado dentro quedaría debajo del header (z-30), sin importar su z-index.
 * - El overlay es el que hace scroll; el panel (`children`) no necesita altura máxima ni
 *   `overflow`, así los dropdowns que se despliegan dentro del panel no se recortan.
 * - `children` es el panel: cada modal conserva su propio estilo y ancho.
 *
 * `align`: "start" (arriba, para formularios largos), "center" o "end" (drawer a la derecha,
 * el panel define su propio scroll).
 */
const WRAPPER = {
  start: "items-start justify-center p-4 sm:py-8",
  center: "items-center justify-center p-4",
  end: "h-full items-stretch justify-end",
};

export default function Modal({
  children,
  onClose,
  closeOnOverlay = false,
  align = "start",
  testId,
  backdrop = "bg-black/40",
  zIndex = "z-50",
}) {
  const onOverlayClick = (e) => {
    if (closeOnOverlay && onClose && e.target === e.currentTarget) onClose();
  };
  return createPortal(
    <div className={`fixed inset-0 ${zIndex} ${backdrop} overflow-y-auto overscroll-contain`} data-testid={testId}>
      <div className={`min-h-full flex ${WRAPPER[align] || WRAPPER.start}`} onClick={onOverlayClick}>
        {children}
      </div>
    </div>,
    document.body,
  );
}
